const Banner = () => {
    return (
        <img
            src="/banner.webp"
            alt="banner"
            className="w-full h-auto"
        />
    );
}

export default Banner;